import { z } from 'zod';
import { NUMBER_FILTER_OPERATION, type NumberFilter } from './operation.js';

export const numberValueSchema = z.number().nullable().optional();

export const numberFilterSchema = z.union([
    z.object({
        operation: z.enum([NUMBER_FILTER_OPERATION.inArray.id]),
        array: z.array(
            z.union([
                z.number(),
                // NOTE: `NaN` is used for the `select all` case
                z.nan(),
            ])
        ),
        includeBlanks: z.boolean().optional(),
    }),
    z.object({
        operation: z.enum([
            NUMBER_FILTER_OPERATION.equals.id,
            NUMBER_FILTER_OPERATION.doesNotEqual.id,
            NUMBER_FILTER_OPERATION.greaterThan.id,
            NUMBER_FILTER_OPERATION.greaterThanOrEqual.id,
            NUMBER_FILTER_OPERATION.lessThan.id,
            NUMBER_FILTER_OPERATION.lessThanOrEqual.id,
        ]),
        value1: z.number().optional(),
    }),
    z.object({
        operation: z.enum([NUMBER_FILTER_OPERATION.between.id]),
        value1: z.number().optional(),
        value2: z.number().optional(),
    }),
]);

export type NumberFilterSchema = z.infer<typeof numberFilterSchema>;
export type NumberFilterSchemaWithoutInArray = Exclude<
    NumberFilterSchema,
    {
        operation: NumberFilter['inArray']['id'];
    }
>;
